import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

export interface TranslationsExport {
  language: string;
  data: Record<string, string>;
}

export const translationsApi = {
  getTranslations: (language: string) =>
    axios
      .get<TranslationsExport>(`${API_BASE_URL}/translations`, {
        params: { language },
        timeout: 10000,
      })
      .then((r) => r.data)
      .catch(() => ({ language, data: {} } as TranslationsExport)),
};
